import React from 'react'
import { Link } from 'react-router-dom'
import './IndustriesWidget.scss'
import InformationImg from '../assets/images/information-technology.jpg'
import HealthCareImg from '../assets/images/healthcare.jpg'
import EcommerceImg from '../assets/images/retail.jpg'
import PublicImg from '../assets/images/publicsector.jpg'
import LegalImg from '../assets/images/legal.jpg'
import ProfessionalImg from '../assets/images/professional.jpg'

const IndustriesWidget = ({ bckColorClass = '', isHomepage = false }) => {
  const companyName = process.env.REACT_APP_COMPANY_NAME
  const industriesData = [
    {
      title: 'Information Technology',
      description:
        'In the fast-evolving world of IT, staying ahead of the curve is critical. Our software contractors bring expertise in system design, software development, cloud computing, and more. Whether you are building custom applications, improving your infrastructure, or developing new solutions, we provide the technical support you need to deliver.',
      image: InformationImg,
    },
    {
      title: 'Legal',
      description:
        'TechTonic offers extensive experience within the legal sector. We support some of the largest law firms in the world with their software requirements. This includes website design, system modernisation, and cloud migration. We ensure each system developed is secure, scalable, and compliant with legal industry standards.',
      image: LegalImg,
      hasCaseStudy: true,
    },
    {
      title: 'E-commerce & Retail',
      description:
        'E-commerce continues to grow at an exponential rate. Companies need software solutions that can scale with consumer demand. We have the skills to design and develop your online store and integrate payment systems. Our solutions will drive sales and ensure an exceptional user experience.',
      image: EcommerceImg,
    },
    {
      title: 'Healthcare',
      description:
        'The healthcare industry is increasingly turning to technology to improve patient care and streamline operations. We work with healthcare providers to create solutions that ensure compliance, security, and accessibility.  From Electronic Patient Record systems to data analytics, we provide expertise to deliver software that improves healthcare outcomes.',
      image: HealthCareImg,
      hasCaseStudy: true,
    },
    {
      title: 'Public Sector',
      description:
        'We partner with public sector organisations to provide secure and scalable software solutions that enhance services, manage data, and meet regulatory standards. We develop technology for the NHS, local government, housing associations, and the education sector, working directly with clients or as subcontractors for larger suppliers.',
      image: PublicImg,
    },
    {
      title: 'Professional Services',
      description:
        'At TechTonic, our experienced contractors specialise in supporting professional services organisations. We partner with consultancy firms and provide services including custom applications, data analysis, and cloud migration. We also offer solutions for banks and insurance companies including risk management and compliance software.',
      image: ProfessionalImg,
      hasCaseStudy: true,
    },
  ];
  const visibleIndustries = isHomepage
    ? industriesData.slice(0, 3)
    : industriesData;

  return (
    <>
      {isHomepage && (
        <div className="container fade-in">
          <h2 className="section-title">Industries</h2>
          <div className="section-heading">
            <h4>SEE OUR WORK</h4>
            <div className="section-description">
              At {companyName}, we deliver high-quality software solutions across a wide
              range of industries.<br></br> Our contractors help customers to innovate,
              streamline, and solve technical challenges.
            </div>
          </div>
        </div>
      )}

      <div className="container fade-in">
        <div className="industries-grid">
          {visibleIndustries.map((industry, index) => (
            <div className="industry-card fade-in-delayed-3s" key={index} style={{ animationDelay: index * 300 + 'ms' }}>
              <img
                src={industry.image}
                alt={industry.title}
                className="industry-image"
              />
              <div className="industry-content">
                <h3 className="industry-title">{industry.title}</h3>
                <p className="industry-description">{industry.description}</p>


                {!isHomepage && industry.hasCaseStudy && (
                  <Link to="/case-studies">
                    <button className="button view-case-studies">
                      View Case Studies
                    </button>
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
        {isHomepage && (
          <a href="/industries" className="button section-cta">View All Industries ➔</a>
        )}
      </div>
    </>
  )
}

export default IndustriesWidget;
